<header
  class="header eye-border-color"
  id="main-header"
  [class.offline]="!network.online"
  [style.padding-right.px]="scrollWidht$ | async"
  stickyHeader
>
  @if (!network.online) {
    <div class="offline-bar">{{ 'OFFLINE_MODE' | translate }}</div>
  }
  <app-browser-deprecation-warning />
  <div class="header__line eye-border-color">
    <app-loader></app-loader>
    <div class="header__container header__container--main container">
      <div class="header__item header__item--main">
        @if (headerMenu()) {
          <!-- Main navigation -->
          <div class="header__item header__item--main">
            <app-header-menu />
          </div>
        } @else if (staticRequestState().loading) {
          <div class="header__loading-container container">
            <app-skeleton />
          </div>
        } @else if (staticRequestState().error) {
          <div class="header__error-container container">
            <p class="header__error-text">
              {{ 'STATICS_ERROR.HEADER_MESSAGE' | translate }}
            </p>
            <button class="user-button" (click)="reload()">
              <span class="header__error-button-text">
                {{ 'STATICS_ERROR.RELOAD' | translate }}
              </span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M7.07292 17.7393C6.16319 17.3435 5.37153 16.8088 4.69792 16.1352C4.02431 15.4616 3.48958 14.6699 3.09375 13.7602C2.69792 12.8505 2.5 11.8748 2.5 10.8331C2.5 10.597 2.57986 10.3991 2.73958 10.2393C2.89931 10.0796 3.09722 9.99977 3.33333 9.99977C3.56944 9.99977 3.76736 10.0796 3.92708 10.2393C4.08681 10.3991 4.16667 10.597 4.16667 10.8331C4.16667 12.4581 4.73264 13.8366 5.86458 14.9685C6.99653 16.1005 8.375 16.6664 10 16.6664C11.625 16.6664 13.0035 16.1005 14.1354 14.9685C15.2674 13.8366 15.8333 12.4581 15.8333 10.8331C15.8333 9.2081 15.2674 7.82963 14.1354 6.69768C13.0035 5.56574 11.625 4.99977 10 4.99977H9.875L10.5833 5.7081C10.75 5.87477 10.8299 6.06921 10.8229 6.29143C10.816 6.51365 10.7361 6.7081 10.5833 6.87477C10.4167 7.04143 10.2188 7.12824 9.98958 7.13518C9.76042 7.14213 9.5625 7.06227 9.39583 6.8956L7.25 4.74977C7.08333 4.5831 7 4.38865 7 4.16643C7 3.94421 7.08333 3.74977 7.25 3.5831L9.39583 1.43727C9.5625 1.2706 9.76042 1.19074 9.98958 1.19768C10.2188 1.20463 10.4167 1.29143 10.5833 1.4581C10.7361 1.62477 10.816 1.81921 10.8229 2.04143C10.8299 2.26365 10.75 2.4581 10.5833 2.62477L9.875 3.3331H10C11.0417 3.3331 12.0174 3.53102 12.9271 3.92685C13.8368 4.32268 14.6285 4.8574 15.3021 5.53102C15.9757 6.20463 16.5104 6.99629 16.9062 7.90602C17.3021 8.81574 17.5 9.79143 17.5 10.8331C17.5 11.8748 17.3021 12.8505 16.9062 13.7602C16.5104 14.6699 15.9757 15.4616 15.3021 16.1352C14.6285 16.8088 13.8368 17.3435 12.9271 17.7393C12.0174 18.1352 11.0417 18.3331 10 18.3331C8.95833 18.3331 7.98264 18.1352 7.07292 17.7393Z"
                  fill="white"
                />
              </svg>
            </button>
          </div>
        }
      </div>
      <div class="header__item header__item--secondary">
        <!-- User actions -->
        <app-header-user />
      </div>
    </div>
  </div>
  <div class="header__container container">
    <!-- Logo, hamburger menu toggle, search -->
    <app-header-panel />
  </div>
</header>
